// Provider-aware record validation shared by the device-only health views.
export function validDeviceWorkout(item) {
  return Boolean(item && (item.provider === "health_connect" && /^hc:[A-Za-z0-9_-]{1,342}$/.test(item.workoutId)
    || item.provider === "apple_health" && /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(item.workoutId)))
}
export const healthProviderName = provider => provider === "apple_health" ? "Apple Health" : "Health Connect"
